import React, {ReactNode} from 'react';
import {Auth0Provider} from '@auth0/auth0-react';
import RemoteServices from '~/constants/RemoteServices';
import {Auth0SilentAuth} from '~/auth/auth0/Auth0SilentAuth';
import {Auth0UserProvider} from '~/auth/auth0/Auth0UserProvider';

export const Auth0ProviderWrapper: React.FC<{children: ReactNode}> = ({
  children
}) => {
  return (
    <Auth0Provider
      domain={RemoteServices.auth0Domain}
      clientId={RemoteServices.auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: RemoteServices.auth0Audience
      }}>
      <Auth0UserProvider>
        <Auth0SilentAuth>{children}</Auth0SilentAuth>
      </Auth0UserProvider>
    </Auth0Provider>
  );
};
